import { render, staticRenderFns } from "./posts.vue?vue&type=template&id=fcba5552&scoped=true"
import script from "./posts.vue?vue&type=script&lang=js"
export * from "./posts.vue?vue&type=script&lang=js"
import style0 from "./posts.vue?vue&type=style&index=0&id=fcba5552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcba5552",
  null
  
)

export default component.exports